module.exports = __webpack_public_path__ + "img/24_10.f15731f9.png";